import { css } from 'emotion';

export namespace styles {
  export const contentWrapper = css({
    fontSize: '1.8rem'
  });
}
